import {
  Input,
  RadioButton,
  RadioGroup,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Carousel,
  CarouselItem,
  Image,
  Link,
  Timeline,
  TimelineItem,
  Card,
  Table,
  TableColumn,
  Drawer
} from "element-ui";
import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Input);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Link);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Drawer);
